module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/n0G2vl/tc-custom/Cover.jpg?1684979270201?1719544934075",
      "alt": "This image is the cover for the book Lucas Stand #1, Lucas Stand"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lucas Stand #1, Lucas Stand\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lucas Stand is a military vet who can't reintegrate into society and has emotionally cut himself off from the people he loves. At his lowest, Lucas does something he can't take back. Hell comes calling, offering him the opportunity to make things right. Demons escaping Hell are upsetting the balance of evil, and now Lucifer has recruited Lucas to send them back. It doesn't matter in what era the demons escape - World War II, old-timey Hollywood, Vietnam, present day - he must learn to fit in both the past and the present. Given new purpose, Lucas starts to rebuild himself and his life, even as he struggles at the human cost that comes with it.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kurt Sutter, Caitlin Kittredge, Jesus Hervas\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0